import { Colors } from '@pancakeswap/uikit'

const baseColors = {
  failure: '#ED4B9E',
  primary: '#34A9FF',
  primaryBright: '#34A9FF',
  primaryDark: '#34A9FF',
  secondary: '#AA34CD',
  success: '#31D0AA',
  warning: '#FFB237',
}

const additionalColors = {
  binance: '#F0B90B',
  overlay: '#452a7a',
  gold: '#FFC700',
  silver: '#B2B2B2',
  bronze: '#E7974D',
}

export const lightColors: Colors = {
  ...baseColors,
  ...additionalColors,
  primary: '#000',
  background: '#fff',
  backgroundDisabled: '#E9EAEB',
  backgroundAlt: '#d0d0d0',
  backgroundAlt2: '#fff',
  cardBorder: '#E7E3EB',
  contrast: '#191326',
  dropdown: '#F6F6F6',
  dropdownDeep: '#EEEEEE',
  invertedContrast: '#eee',
  input: '#eee',
  inputSecondary: '#fff',
  tertiary: '#EFF4F5',
  text: '#000',
  textDisabled: '#777',
  textSubtle: '#444',
  disabled: '#E9EAEB',
  gradients: {
    bubblegum: 'linear-gradient(to bottom,#ffdafe 70%,#ab57cd 100%);',
    inverseBubblegum: 'linear-gradient(139.73deg, #F3EFFF 0%, #E5FDFF 100%)',
    cardHeader: 'linear-gradient(111.68deg, #F2ECF2 0%, #E8F2F6 100%)',
    blue: 'linear-gradient(180deg, #A7E8F1 0%, #94E1F2 100%)',
    violet: 'linear-gradient(180deg, #E2C9FB 0%, #CDB8FA 100%)',
    violetAlt: 'linear-gradient(180deg, #CBD7EF 0%, #9A9FD0 100%)',
    gold: 'linear-gradient(180deg, #FFD800 0%, #FDAB32 100%)',
  },
}

export const darkColors: Colors = {
  ...baseColors,
  ...additionalColors,
  secondary: '#fff',
  background: '#000',
  backgroundDisabled: '#333333',
  backgroundAlt: '#222222',
  backgroundAlt2: '#fff',
  cardBorder: '#303033',
  contrast: '#FFFFFF',
  disabled: '#111111',
  dropdown: '#1E1D20',
  dropdownDeep: '#000',
  failure: '#e9602a',
  invertedContrast: '#383838',
  input: '#222',
  inputSecondary: '#000',
  primary: '#5ED3F0',
  primaryDark: '#0098A1',
  tertiary: '#606060',
  text: '#fff',
  textDisabled: '#666171',
  textSubtle: '#999',
  gradients: {
    bubblegum: 'linear-gradient(139.73deg, #313D5C 0%, #3D2A54 100%)',
    inverseBubblegum: 'linear-gradient(139.73deg, #3D2A54 0%, #313D5C 100%)',
    cardHeader: '#000',
    blue: 'linear-gradient(180deg, #00707F 0%, #19778C 100%)',
    violet: 'linear-gradient(180deg, #6C4999 0%, #6D4DB2 100%)',
    violetAlt: 'linear-gradient(180deg, #434575 0%, #66578D 100%)',
    gold: 'linear-gradient(180deg, #FFD800 0%, #FDAB32 100%)',
  },
}
